import React, { useState, useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import { NodesAPI } from '../../../api';
import { TableNodes } from '../../../components/Admin/Nodes';
import { FilterNodes } from '../../../components/Admin/Nodes';
import { NodesModal } from '../../../components/Shared';
import { FormNodes } from '../../../components/Admin/Nodes';
import { useAuth } from '../../../hooks';

import './Nodes.scss';
import { useParams } from "react-router";
const nodesController = new NodesAPI();

export function Nodes() {
  let { statusNodes } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectEntityNode, setSelectEntityNode] = useState('');
  const [selectNetworkName, setSelectNetworkName] = useState(undefined);
  const [selectStatus, setSelectStatus] = useState(undefined);
  const [nodes, setNodes] = useState(null);
  const [reload, setReload] = useState(false);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
      
        const response = await nodesController.getNodes(accessToken,statusNodes);
        setNodes(response);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [reload,accessToken,statusNodes]);

  const getNodesExcel = async () => {
    try {
      console.log(accessToken);
      await nodesController.getNodeExcel(accessToken);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  

  //if (size(nodes) === 0) return <p>not results</p>;
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState)

 
  // recargar la table
  const onReload = () => setReload((prevState) => !prevState);

  const handleSelectEntity = (e) => {
    setSelectEntityNode(e.target.value);
  }

  const handleSelectNetworkName = (e) => {
    setSelectNetworkName(e.target.value);
  }

  const handleSelectStatus = async(e) => {
    //setSelectStatus(e.target.value);
    try {
  
       const response = await nodesController.getNodes(accessToken,e.target.value);
       setNodes(response);
     } catch (error) {
       console.log(error);
     }
  }

  return (
    <>
      <div className='nodes-page'>

        <FilterNodes 
          nodes={nodes}
          selectEntityNode={selectEntityNode}
          selectNetworkName={selectNetworkName}
          selectStatus={selectStatus}
          handleSelectEntity={handleSelectEntity}
          handleSelectNetworkName={handleSelectNetworkName}
          handleSelectStatus={handleSelectStatus}
        />

        <Button
          className='nodes-page__save-button'
          secondary
          onClick={getNodesExcel}
        >
          Export Excel
        </Button>
        
        <Button
          className='nodes-page__create-button'
          primary
          onClick={onOpenCloseModal}
        >
          Create Node
        </Button>

      </div>
     
        <TableNodes 
          nodes={nodes} 
          onReload={onReload} 
          selectEntityNode={selectEntityNode}
          selectNetworkName={selectNetworkName}
          selectStatus={selectStatus}
        />
        
        <NodesModal
          show={showModal}
          close={onOpenCloseModal}
          title="Create Node"
        >
          <FormNodes close={onOpenCloseModal} onReload={onReload}/>
        </NodesModal>
    </>
  );
}
